module.exports = __webpack_public_path__ + "img/logo.a75e2b19.svg";